import apiClient from './apiClient'


const getEventlog = (tenant, dateFrom, dateTo, skip, take) => {
  const params = {
    tenant,
    dateFrom,
    dateTo,
    skip,
    take
  }
  return apiClient.get(`/${tenant}/EventLog`, { params })
}


export default {
  getEventlog
}
